export default __webpack_public_path__ + "static/media/1869.f6e16ab8.png";